<pf-dropdown [hideArrow]="true" class="user-menu">
    <a (click)="logout()" class="log-out">
        Sign out
    </a>
    <div slot="button">
        <a class="nav-link mr-3">
            <button type="button" class="btn btn-primary">Profile</button>
        </a>
    </div>
    <div slot="menu">
        
        <!-- Menu Body -->
        
        <!-- Menu Footer-->
        <li class="user-footer">
            <a (click)="logout()" class="log-out">
                Sign out
            </a>
        </li>
    </div>
</pf-dropdown>
